module.exports = "请提供一个能够重现你的问题的 GitHub 仓库。\n\n[什么是*最小化重现*，为什么这是必需的？](#why-repro)\n"